import {Component,OnInit,ChangeDetectorRef,ViewChild,ElementRef,TemplateRef,} from "@angular/core";
import { MainService } from "src/app/services/main-service.service";
import { ProposalService } from "src/app/services/proposal/proposal.service";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import {
  BsDatepickerConfig,
  BsDatepickerDirective,
} from "ngx-bootstrap/datepicker";
import { CompressImageService } from "src/app/services/compress-image.service";
import { take } from "rxjs/operators";
import { BsModalRef,BsModalService,ModalDirective} from "ngx-bootstrap/modal";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { environment } from "src/environments/environment";
import { DateAdapter,MAT_DATE_LOCALE} from "@angular/material/core";
import { CustomDateAdapter } from "src/app/shared/date-time/date-adapter.service";
import * as moment from "moment";
import { ToasterService } from "src/app/services/toaster.service";
@Component({
  selector: "app-personal-details",
  templateUrl: "./personal-details.component.html",
  styleUrls: ["./personal-details.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    [
      CustomDateAdapter, // so we could inject services to 'CustomDateAdapter'
      { provide: DateAdapter, useClass: CustomDateAdapter }, // Parse MatDatePicker Format
    ],
  ],
})
export class PersonalDetailsComponent implements OnInit {
  flag_code = "";
  patientData: any = {
    is_minor: 1,
    guardian_title: "",
    guardian_first_name: "",
    guardian_last_name: "",
    title: "",
    patient_first_name: "",
    patient_last_name: "",
    date_of_birth: "",
    patient_ssn: "",
    patient_gender: "",
    patient_mobile: "",
    patient_email: "",
    patient_address: "",
    zip: "",
    city: "",
    state_name: "",
    employer_name: "",
    employer_mobile: "",
    employer_address: "",
    employer_address_2: "",
    employer_zip: "",
    employer_city: "",
    employer_state: "",
    annual_income: "",
    office_city_id: "",
    office_address: "",
    office_address_2: "",
    office_city: "",
    office_state: "",
    office_zip: "",
    employer_mobile_country_code: "",
  };
  doc_id: "";
  modalRef: BsModalRef;
  contractToken: any;
  zips: any[] = [];
  empZips: any[] = [];
  LABEL: any = this.mainService.LABEL;
  isOpen = true;
  isOpen2 = false;
  planInfo: any = {};
  mask: any = [
    /[1-9]/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  ssn_mask: any = [
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  zip_mask: any = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  subscription3: any;
  bsConfig = {
    showWeekNumbers: false,
    containerClass: "theme-blue",
    dateInputFormat: "MM/dd/yyyy",
  };
  payment_source = [
    { id: 1, name: "Family" },
    { id: 2, name: "Guardian" },
    { id: 3, name: "Siblings" },
    { id: 4, name: "Spouse" },
    { id: 5, name: "Acquaintance" },
    { id: 6, name: "Social Security Benefits" },
    { id: 7, name: "Crowdfunding/Fundraising" },
    { id: 8, name: "Others" },
  ];
  selectedValue = null;
  @ViewChild("dobdp") private _picker: BsDatepickerDirective;
  @ViewChild("fileUpload") fileUpload: ElementRef;
  @ViewChild("paymentModal") paymentModal: ModalDirective;
  @ViewChild("myInput") myInputElementRef: ElementRef;
  maxDate: Date = new Date();
  minDate: Date;
  isFirstDisabled = false;
  isSecondDisabled = false;
  isDownloadContract = true;
  loadingZip = false;
  imageUploader: any;
  selected_modal;
  employer_yes_id: number = 1;
  selectedOtherValue: any;
  other_services = false;
  other_service_value = null;
  @ViewChild("successModal") successModal: TemplateRef<any>;
  ofcZips: any = [
    {
      zip: "",
      city_id: "",
      state_name: "",
      city: "",
    },
  ];
  is_android_device = /(android)/i.test(navigator.userAgent);
  current_step = 6;
  empzip: any;
  ofczip: any;
  office_address_check: any;
  settingsData: any = {};
  date = new Date();
  mobile_pattern: any;
  getDate: Date;
  fileName: any;

  showvalidation: boolean = false;
  Dlshowvalidation: boolean = false;
  paymentDetails: any;
  selectedPlanIndex: any;
  verified = 0;
  disableInput: string;
  valueTrue: boolean = false;
  valueSet: string;
  toaster_error: string;
  stepHeader: any;
  skip_employment_status: number = 0;
  public specialCharacter = this.mainService.specialCharacter;
  public placeFormat = this.mainService.placeFormat;
  public dateOfBirthMask = this.mainService.dateOfBirthMask;
  regexMode: any;
  mobile_validation: any;
  timezone: any;
  constructor(
    public mainService: MainService,
    public proposal: ProposalService,
    public toaster: ToasterService,
    public route: ActivatedRoute,
    public router: Router,
    public datePipe: DatePipe,
    public cd: ChangeDetectorRef,
    private compressImage: CompressImageService,
    private modalService: BsModalService,
    private _el: ElementRef
  ) {}

  ngOnInit() {
    this.mainService.current_step = this.current_step;
    this.mainService.topHeader.subscribe((data) => {
      this.stepHeader = data;
      console.log(this.stepHeader);
    });
    this.selectedPlanIndex = JSON.parse(localStorage.getItem("INDEX"));
    this.fileName = localStorage.getItem("fileName");
    if (this.fileName) {
      this.fileName = JSON.parse(JSON.stringify(this.fileName));
    }
    this.minDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 120)
    );
    this.route.params.subscribe((data: any) => {
      this.contractToken = data.token;
    });
    this.mainService.regex$.subscribe((data:any) => {
      if(data) {
        this.regexMode = data.DL;
        console.log(data,this.regexMode);
      }
    })

    this.proposal.getData().subscribe((data: any) => {
      this.timezone = data?.timezone || data?.split_request_data?.[0]?.timezone || data?.result?.timezone || '+0000';
      setTimeout(() => {
        this.planInfo = data.split_request_data[0];
        this.skip_employment_status = this.planInfo &&  this.planInfo.skip_employment_status;
        if (this.planInfo.start_date && this.planInfo.end_date) {
          this.specialCharacter = this.mainService.specialCharacter;
          this.placeFormat = this.mainService.placeFormat;
          this.dateOfBirthMask = this.mainService.dateOfBirthMask;
          let today = new Date();
          let start_date = new Date(this.planInfo.start_date);

          if (today > start_date) {
            start_date = new Date(new Date().setDate(new Date().getDate() + 1));
          }
          // tslint:disable:radix
          const first_recurring_days = data.split_request_data[0]
            .first_recurring_days
            ? data.split_request_data[0].first_recurring_days
            : 0;
          this.planInfo.min_date = new Date(
            parseInt(this.datePipe.transform(start_date, "yyyy", this.timezone)),
            parseInt(this.datePipe.transform(start_date, "MM", this.timezone)) - 1,
            parseInt(this.datePipe.transform(start_date, "dd", this.timezone)) +
            (this.planInfo.recurring_days - 1)
          );
          let rec_days =
            this.planInfo && this.planInfo.contract_type == 6
              ? this.planInfo.first_recurring_days_deferred
              : this.planInfo.split_plan_gap_days;

          this.planInfo.max_date = new Date(
            parseInt(
              this.datePipe.transform(this.planInfo.end_date, "yyyy", this.timezone)
            ),
            parseInt(
              this.datePipe.transform(this.planInfo.end_date, "MM", this.timezone)
            ) - 1,
            parseInt(
              this.datePipe.transform(this.planInfo.end_date, "dd", this.timezone)
            ) + (rec_days || 30)
          );
          if (this.planInfo.is_ar_contract == 1) {
            const add_1_month = new Date(
              parseInt(this.datePipe.transform(start_date, "yyyy", this.timezone)),
              parseInt(this.datePipe.transform(start_date, "MM", this.timezone)) - 1,
              parseInt(this.datePipe.transform(start_date, "dd", this.timezone)) +
              (first_recurring_days - 1)
            );
            this.planInfo.max_date = add_1_month;
            const end_date = new Date(
              parseInt(
                this.datePipe.transform(this.planInfo.start_date, "yyyy", this.timezone)
              ),
              parseInt(
                this.datePipe.transform(this.planInfo.start_date, "MM", this.timezone)
              ) - 1,
              parseInt(
                this.datePipe.transform(this.planInfo.start_date, "dd", this.timezone)
              ) + first_recurring_days
            );
            if (add_1_month > end_date) {
              this.paymentDetails = this.planInfo.max_date;
            } else {
              this.planInfo.max_date = end_date;
              this.paymentDetails = add_1_month;
            }
          } else {
            rec_days =
              this.planInfo && this.planInfo.contract_type == 6
                ? this.planInfo.first_recurring_days_deferred
                : first_recurring_days;

            const add_1_month = new Date(
              parseInt(this.datePipe.transform(start_date, "yyyy", this.timezone)),
              parseInt(this.datePipe.transform(start_date, "MM", this.timezone)) - 1,
              parseInt(this.datePipe.transform(start_date, "dd", this.timezone)) +
              (rec_days - 1)
            );
            const end_date = new Date(
              parseInt(
                this.datePipe.transform(this.planInfo.end_date, "yyyy", this.timezone)
              ),
              parseInt(
                this.datePipe.transform(this.planInfo.end_date, "MM", this.timezone)
              ) - 1,
              parseInt(
                this.datePipe.transform(this.planInfo.end_date, "dd", this.timezone)
              ) + rec_days
            );
            if (add_1_month > end_date) {
              this.planInfo.max_date = end_date;
              this.paymentDetails = this.planInfo.max_date;
            } else {
              this.paymentDetails = add_1_month;
            }
          }
          this.planInfo.max_date = this.paymentDetails;
          // setting pre-selected last date from the calendar in AR and now in financing as well.
          // if (this.planInfo && this.planInfo.is_ar_contract == 1) {
          // this.paymentDetails.recurringDate = this.planInfo.max_date;
          // }
          this.planInfo.selected_plan =
            this.planInfo.plans_array[this.selectedPlanIndex];

        }
        if (this.planInfo.request_from != 0) {
          if (
            this.planInfo.next_payment_start_date &&
            this.planInfo.next_payment_end_date
          ) {
            if (
              this.mainService.getExactDate(
                new Date(this.planInfo.next_payment_end_date)
              ) > this.mainService.getExactDate(new Date())
            ) {
              this.paymentDetails =
                this.mainService.getExactDate(
                  new Date(this.planInfo.next_payment_start_date)
                ) > this.mainService.getExactDate(new Date())
                  ? this.mainService.getExactDate(
                    new Date(this.planInfo.next_payment_start_date)
                  )
                  : new Date(new Date().setDate(new Date().getDate() + 1));
              this.planInfo.min_date = this.paymentDetails;
              this.planInfo.max_date = this.mainService.getExactDate(
                new Date(this.planInfo.next_payment_end_date)
              );
            } else if (
              this.planInfo.next_payment_buffer_days &&
              this.planInfo.next_payment_buffer_days > 0
            ) {
              this.paymentDetails = new Date(
                new Date().setDate(new Date().getDate() + 1)
              );
              this.planInfo.min_date = new Date(
                new Date().setDate(new Date().getDate() + 1)
              );
              this.planInfo.max_date = new Date(
                parseInt(this.datePipe.transform(new Date(), "yyyy", this.timezone)),
                parseInt(this.datePipe.transform(new Date(), "MM", this.timezone)) - 1,
                parseInt(this.datePipe.transform(new Date(), "dd", this.timezone)) +
                this.planInfo.next_payment_buffer_days
              );
            }
          } else if (
            this.planInfo.next_payment_buffer_days &&
            this.planInfo.next_payment_buffer_days > 0
          ) {
            this.paymentDetails = new Date(
              new Date().setDate(new Date().getDate() + 1)
            );
            this.planInfo.min_date = new Date(
              new Date().setDate(new Date().getDate() + 1)
            );
            this.planInfo.max_date = new Date(
              parseInt(this.datePipe.transform(new Date(), "yyyy", this.timezone)),
              parseInt(this.datePipe.transform(new Date(), "MM", this.timezone)) - 1,
              parseInt(this.datePipe.transform(new Date(), "dd", this.timezone)) +
              this.planInfo.next_payment_buffer_days
            );
          }
        }

        
        if (this.planInfo.contract_id == 0) {
          this.router.navigate(["plans", this.contractToken]);
        }
        if (data && data.patients && data.patients.length > 0) {
          this.patientData = data.patients[0];
          console.log(this.patientData);

          if (!this.patientData.employer_mobile_country_code) {
            if (
              data &&
              data["doctor_country_currency_info"] &&
              data["doctor_country_currency_info"]["country"]
            ) {
              // tslint:disable-next-line:no-string-literal
              this.patientData.employer_mobile_country_code =
                data["split_request_data"][0]["patient_mobile_country_code"];
              this.flag_code = (
                data["doctor_country_currency_info"]["country"]["country_code"] +
                ""
              ).toLocaleLowerCase();
            }
            if (data["split_request_data"] && (data["split_request_data"][0].country_id == 7)) {
              this.australiaChange(data["split_request_data"][0].patient_mobile_country_code);
            } else if (data.doctor_country_currency_info) {
              this.mainService.showSSNFields =
                data.doctor_country_currency_info["SSN"];
              this.mobile_pattern = data.doctor_country_currency_info["mobile_regex"];
              this.updateMasking(
                data.doctor_country_currency_info["country"]["country_phone_format"]
              );
            }
          } else {
            if (
              this.mainService.country_data &&
              this.mainService.country_data.length
            ) {
              this.flag_code = this.mainService.findFlagCode(
                this.patientData.employer_mobile_country_code
              );
            }
          }
          if (this.patientData.zip) {
            this.patientData.zipSelected = true;
            this.zips[0] = {
              city_id: this.patientData.city_id ? this.patientData.city_id : "",
              zip: this.patientData.zip ? this.patientData.zip : "",
              city: this.patientData.city ? this.patientData.city : "",
              state_name: this.patientData.state_name
                ? this.patientData.state_name
                : "",
              country_code: this.patientData.country_code
                ? this.patientData.country_code
                : "",
            };
          }
          if (this.patientData.employer_zip) {
            this.patientData.zipEmpSelected = true;
            this.empZips[0] = {
              city_id: this.patientData.employer_city_id
                ? this.patientData.employer_city_id
                : "",
              zip: this.patientData.employer_zip
                ? this.patientData.employer_zip
                : "",
              city: this.patientData.employer_city
                ? this.patientData.employer_city
                : "",
              state_name: this.patientData.employer_state_name
                ? this.patientData.employer_state_name
                : "",
              country_code: this.patientData.employer_country_code
                ? this.patientData.employer_country_code
                : "",
            };
          }
        }
        if (localStorage.getItem('contract_code')) {
          this.planInfo.contract_code = localStorage.getItem('contract_code');
        }
        this.patientData.patient_first_name = this.planInfo.patient_first_name;
        this.patientData.patient_last_name = this.planInfo.patient_last_name;
        this.patientData.patient_email = this.planInfo.patient_email;
        this.patientData.patient_mobile = this.planInfo.patient_mobile;
        if (
          this.patientData.patient_mobile &&
          this.patientData.patient_mobile.split("-").length > 1
        ) {
          this.patientData.patient_mobile =
            this.patientData.patient_mobile.split("-")[1];
        }
        // if (this.patientData.date_of_birth) {
        //   this.patientData.date_of_birth = new Date(this.patientData.date_of_birth);
        // }
      }, 200);
    });
    this.mainService.getMsg().subscribe((data: any) => {
      this.settingsData = data;
      // Stripe.setPublishableKey(data.stripe_pk);
      // console.log(this.settingsData);
    });
    this.mainService.country_data$.subscribe((data) => {
      if (
        data &&
        data.length &&
        !this.patientData.employer_mobile_country_code
      ) {
        this.patientData.employer_mobile_country_code = data[0]["mobile_code"];
        this.changeFlag(0, data);
      }
    });
    // if (this.patientData.is_minor == 1) {

    //   let dte = new Date();
    //   // const dateComes =new Date (dte);
    //   this.getDate = new Date(dte)
    //   this.getDate.setFullYear(dte.getFullYear() - 18);
    // }
    this.route.queryParams.subscribe((params) => {
      let token = JSON.parse(localStorage.getItem('x-token'));
      if(token && !params['x-token']){
        this.router.navigate([], {
          relativeTo:this.route,
          queryParams: { 'x-token':token },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }})
  }
  updateMasking(format: any) {
    format = format ? format : "";
    this.mask = format.replace(/#/g, "0");
    // this.mask = '0000-000-000';
  }
  // goToCustomerDetails() {
  //   this.router.navigate(['/thanks/'] , this.contractToken)
  // }
  detectChange() {
    this.cd.detectChanges();
  }

  toggleAccordion1(ev: any) {
    this.isOpen = ev;
  }

  toggleAccordion2(ev: any) {
    this.isOpen2 = ev;
  }

  toggleIsOpen(form: any) {
    if (this.validateFirstStep()) {
      this.mainService.scrollToTop();
      this.isOpen = !this.isOpen;
      this.isOpen2 = !this.isOpen2;
    } else {
      return false;
    }
  }
  getValueDates() {
    this.patientData.date_of_birth = this.patientData.date_of_birth;
  }

  validateFirstStep(from?: any, hideToaster?: any) {

    if (!from) {
      from.markAsTouched();
    }
    const getYearThreshold = new Date().getFullYear() - 120;
    const currentDateThreshold = new Date().getDate();
    const currentMonthThreshold = new Date().getMonth() + 1;
    const currentDateYear = new Date().getFullYear();
    let getDate = JSON.parse(JSON.stringify(this.patientData.date_of_birth));
    getDate = moment(getDate, this.mainService.placeFormat).format(
      "MM" +
        this.mainService.specialCharacter[0] +
        "DD" +
        this.mainService.specialCharacter[0] +
        "YYYY"
    );
    if (!getDate || getDate == "Invalid date") {
      if (!hideToaster) {
        // this.toaster.message('error', 'Please enter date of birth');
        this.toaster_error = "Please enter date of birth" + ' ' + `${this.placeFormat}`;
        if (this._el.nativeElement.querySelector('[name="dob"]')) {
          this._el.nativeElement.querySelector('[name="dob"]').focus();
        }
        this.showvalidation = true;
      }
      return false;
    }
    if (
      getDate.includes("-") ||
      getDate.includes("/") ||
      getDate.includes(".")
    ) {
      const change =
        getDate.slice(0, 2) +
        "/" +
        getDate.slice(3, 5) +
        "/" +
        getDate.slice(6, 10);
      this.valueSet = change;
    } else {
      const change =
        getDate.slice(0, 2) +
        "/" +
        getDate.slice(2, 4) +
        "/" +
        getDate.slice(4, 8);
      this.valueSet = change;
    }
    if (this.valueSet.includes("/")) {
      const datepart = this.valueSet && this.valueSet.split("/");
      // Extract the string into month, date and year
      // let datepart = [];
      // if (values.length > 1) {
      //     datepart = date.split('/');
      // }
      const month = parseInt(datepart[0]);
      const day = parseInt(datepart[1]);
      const year = parseInt(datepart[2]);
      // Create a list of days of a month
      const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (month === 1 || month > 2) {
        if (day > ListofDays[month - 1]) {
          this.toaster_error = "Please enter a valid date of birth";
          this.showvalidation = true;
          return false;
        }
      } else if (month === 2) {
        let leapYear = false;
        if ((!(year % 4) && year % 100) || !(year % 400)) {
          leapYear = true;
        }
        if (leapYear === false && day >= 29) {
          this.toaster_error = "Please enter a valid date of birth";
          this.showvalidation = true;
          return false;
        } else if (leapYear && day > 29) {
          this.toaster_error = "Please enter a valid date of birth";
          this.showvalidation = true;
          return false;
        }
      }
      if (
        Number(datepart[2]) === currentDateYear &&
        month >= currentMonthThreshold
      ) {
        if (day > currentDateThreshold) {
          this.toaster_error = "Please enter a valid date of birth";
          if (this._el.nativeElement.querySelector('[name="dob"]')) {
            this._el.nativeElement.querySelector('[name="dob"]').focus();
          }
          return;
        }
        if (month > currentMonthThreshold) {
          this.toaster_error = "Please enter a valid date of birth";
          if (this._el.nativeElement.querySelector('[name="dob"]')) {
            this._el.nativeElement.querySelector('[name="dob"]').focus();
          }
          return;
        }
      }
      if (datepart[0] === "00" || datepart[1] === "00") {
        this.toaster_error = "Please enter a valid date of birth";
        this.showvalidation = true;
        if (this._el.nativeElement.querySelector('[name="dob"]')) {
          this._el.nativeElement.querySelector('[name="dob"]').focus();
        }
        return;
      }
      if (!datepart[0] || !Number(datepart[1]) || !Number(datepart[2])) {
        this.toaster_error = "Please enter a valid date of birth";
        if (this._el.nativeElement.querySelector('[name="dob"]')) {
          this._el.nativeElement.querySelector('[name="dob"]').focus();
        }
        this.showvalidation = true;
        return;
      }
      if (
        Number(datepart[2]) < getYearThreshold ||
        Number(datepart[2]) > currentDateYear
      ) {
        if (Number(datepart[2]) < getYearThreshold) {
          if (Number(datepart[2].length < 4)) {
            this.toaster_error =
              "Please enter date of birth" +' '+ `${this.placeFormat}`;
          } else {
            this.toaster_error = "Please enter a valid date of birth";
          }
        } else {
          this.toaster_error = "Please enter a valid date of birth";
        }
        if (this._el.nativeElement.querySelector('[name="dob"]')) {
          this._el.nativeElement.querySelector('[name="dob"]').focus();
        }
        this.showvalidation = true;
        return;
      }
    }

    if (this.patientData.is_minor) {
      if (
        !this.patientData.guardian_first_name ||
        this.patientData.guardian_first_name.trim().length == 0
      ) {
        if (!hideToaster) {
          if (
            this._el.nativeElement.querySelector('[name="guardian_first_name"]')
          ) {
            this._el.nativeElement
              .querySelector('[name="guardian_first_name"]')
              .focus();
          }
          this.showvalidation = true;
          //  this.toaster.message('warning', 'Please enter guardian first name');
        }
        return false;
      }

      if (
        !this.patientData.guardian_last_name ||
        this.patientData.guardian_last_name.trim().length == 0
      ) {
        if (!hideToaster) {
          if (
            this._el.nativeElement.querySelector('[name="guardian_last_name"]')
          ) {
            this._el.nativeElement
              .querySelector('[name="guardian_last_name"]')
              .focus();
          }
          this.showvalidation = true;
          // this.toaster.message('warning', 'Please enter guardian last name');
        }
        return false;
      }
    }

    if (
      !this.patientData.patient_first_name ||
      this.patientData.patient_first_name.trim().length == 0
    ) {
      if (!hideToaster) {
        if (
          this._el.nativeElement.querySelector('[name="patient_first_name"]')
        ) {
          this._el.nativeElement
            .querySelector('[name="patient_first_name"]')
            .focus();
        }
        this.showvalidation = true;
        //  this.toaster.message('warning', 'Please enter first name');
      }
      return false;
    }

    if (
      !this.patientData.patient_last_name ||
      this.patientData.patient_last_name.trim().length == 0
    ) {
      if (!hideToaster) {
        // this.toaster.message('warning', 'Please enter last name');
        if (
          this._el.nativeElement.querySelector('[name="patient_last_name"]')
        ) {
          this._el.nativeElement
            .querySelector('[name="patient_last_name"]')
            .focus();
        }
        this.showvalidation = true;
      }
      return false;
    }

    if (
      this.patientData.patient_gender < 1 ||
      !this.patientData.patient_gender
    ) {
      if (!hideToaster) {
        if (this._el.nativeElement.querySelector('[name="patient_gender"]')) {
          this._el.nativeElement
            .querySelector('[name="patient_gender"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please select gender');
      }
      return false;
    }

    // if (!this.patientData.patient_email || this.patientData.patient_email.trim().length == 0) {
    //   if (!hideToaster) { this.toaster.message('warning', 'Please enter email address'); }
    //   return false;
    // }
    this.patientData.patient_mobile = this.patientData.patient_mobile.replace(
      /-/g,
      ""
    );
    // if (!this.patientData.patient_mobile || this.patientData.patient_mobile.trim().length < 10) {
    //   if (!hideToaster) { this.toaster.message('warning', 'Please enter phone number'); }
    //   return false;
    // }

    // if (!this.patientData.zip || !this.patientData.zipSelected) {
    //   if (!hideToaster) { this.toaster.message('warning', 'Please enter Zip/ Postal code'); }
    //   return false;
    // }
    // if (!this.patientData.patient_address || this.patientData.patient_address.trim().length == 0) {
    //   if (!hideToaster) { this.toaster.message('warning', 'Please enter address'); }
    //   return false;
    // }

    // if (!this.patientData.patient_ssn) {
    //   if (!hideToaster) { this.toaster.message('warning', 'Please enter Social Security number'); }
    //   return false;
    // }

    // if (this.patientData.patient_ssn && this.mainService.showSSNFields) {
    //   this.patientData.patient_ssn = this.patientData.patient_ssn;
    //   let patient_ssn = this.patientData.patient_ssn;
    //   var invalid_ssn = ["002281852", "042103580", "062360749", "078051120", "095073645", "128036045", "135016629", "141186941", "165167999", "165187999", "165207999", "212099999", "165227999", "306302348", "165247999", "189092294", "308125070", "212097694", "549241889", "468288779"];
    //   if (patient_ssn.trim().length != 9) {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (/^(.)\1+$/.test(patient_ssn)) {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (!(/^[a-zA-Z0-9]*$/.test(patient_ssn))) {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (patient_ssn.slice(0, 3) == "000" || patient_ssn.slice(0, 3) == "666") {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (invalid_ssn.indexOf(patient_ssn) >= 0) {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (parseInt(patient_ssn) >= 987654320 && parseInt(patient_ssn) <= 987654329) {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   } else if (patient_ssn.slice(9, 4) == "0000") {
    //     if (!hideToaster) { this.toaster.message('warning', 'Please enter valid SSN number', ''); }
    //     return false;
    //   }
    // }

    if ((!this.patientData.dl_number || this.patientData.dl_number.trim().length == 0) || (this.patientData.dl_number.length < this.regexMode.min || this.patientData.dl_number.length > this.regexMode.max) || this.Dlshowvalidation) {
      if (!hideToaster) {
        if (this._el.nativeElement.querySelector('[name="dl_number"]')) {
          this._el.nativeElement.querySelector('[name="dl_number"]').focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter Driving License number');
      }
      return false;
    }

    if (this.planInfo && this.planInfo.upload_customer_document && this.planInfo.upload_customer_document == 1) {
      if ((this.planInfo && this.planInfo.upload_customer_document && this.planInfo.cus_doc_required == 1)) {
        if ((this.patientData && (!this.patientData.dl_doc || this.patientData.dl_doc == null))) {
          if (!hideToaster) {
            if (this._el.nativeElement.querySelector('[name="imgUploader"]')) {
              this._el.nativeElement
                .querySelector('[name="imgUploader"]')
                .focus();
            }
            this.showvalidation = true;
            // this.toaster.message('warning', 'Please upload the Proof of ID');
          }
          return false;
        }
      }
    }
    if (this.planInfo.is_ar_contract) {
      this.submitPersonalDetailsAR();
    } else {
      //NORMAL FLOW
      if (this.skip_employment_status != 1) {
        this.showvalidation = false;
        this.current_step = 7;
        this.patientData.annual_income = "";
      }
    }
    if (this.skip_employment_status == 1) {
      this.employer_yes_id = 0;
      this.selectedValue = "Others";
      this.other_service_value = "SELF";
      this.submitPersonalDetails(from);
    } else {
      this.mainService.current_step = this.current_step;
      this.mainService.closePayBtn = true;
    }

    return true;
  }
  changeScreen() {
    this.current_step = this.current_step - 1;
    this.mainService.closePayBtn = false;
  }

  validateSecondStep() {
    // if (!this.patientData.employer_name || this.patientData.employer_name.trim().length == 0) {
    //   this.toaster.message('warning', 'Please enter employer name');
    //   return false;
    // }

    // if (!this.patientData.employer_mobile || this.patientData.employer_mobile.trim().length == 0) {
    //   this.toaster.message('warning', 'Please enter employer phone number');
    //   return false;
    // }

    // if (!this.patientData.employer_address || this.patientData.employer_address.trim().length == 0) {
    //   this.toaster.message('warning', 'Please enter employer address');
    //   return false;
    // }

    // if (!this.patientData.employer_zip || !this.patientData.zipEmpSelected) {
    //   this.toaster.message('warning', 'Please enter employer zipcode');
    //   return false;
    // }

    // if (this.patientData.annual_income == undefined || this.patientData.annual_income == null || this.patientData.annual_income < 0) {
    //   this.toaster.message('warning', 'Please enter annual income');
    //   return false;
    // }
    return true;
  }

  submitPersonalDetails(form?: any) {
    if (this.employer_yes_id == null) {
      if (this._el.nativeElement.querySelector('[name="is_minor"]')) {
        this._el.nativeElement.querySelector('[name="is_minor"]').focus();
      }
      this.showvalidation = true;
      this.toaster.message("Please Choose from the above options", 2);
      return false;
    }
    if (this.employer_yes_id == 1) {
      if (
        !this.patientData.employer_name ||
        (this.patientData.employer_name &&
          this.patientData.employer_name.trim().length === 0)
      ) {
        if (this._el.nativeElement.querySelector('[name="employerName"]')) {
          this._el.nativeElement.querySelector('[name="employerName"]').focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter employer name');
        return false;
      }
      // tslint:disable-next-line:max-line-length
      // this.patientData.employer_mobile = this.patientData.employer_mobile && this.patientData.employer_mobile.replace(/-/g, '');
      // if (!this.patientData.employer_mobile || (this.patientData.employer_mobile && this.patientData.employer_mobile.trim().length === 0) || (this.patientData.employer_mobile && this.patientData.employer_mobile.trim().length < 10)) {
      //   this.toaster.message('warning', 'Please enter a valid employer mobile');
      //   return false;
      // }
      if (
        !new RegExp(this.mobile_pattern).test(
          this.patientData.employer_mobile_country_code +
            this.patientData.employer_mobile
        )
      ) {
        if (this._el.nativeElement.querySelector('[name="employerPhone"]')) {
          this._el.nativeElement
            .querySelector('[name="employerPhone"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter a valid employer mobile');
        return false;
      }
      if (
        !this.patientData.employer_address ||
        this.patientData.employer_address.trim().length === 0
      ) {
        if (this._el.nativeElement.querySelector('[name="employerAddress"]')) {
          this._el.nativeElement
            .querySelector('[name="employerAddress"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter employer address');
        return false;
      }
      if (!this.patientData.employer_city_id) {
        if (this._el.nativeElement.querySelector('[name="employerCity"]')) {
          this._el.nativeElement.querySelector('[name="employerCity"]').focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter employer zip / Postal Code');
        return false;
      }
      if (parseInt(this.patientData.annual_income, 10) == 0) {
        if (this._el.nativeElement.querySelector('[name="employerCity"]')) {
          this._el.nativeElement.querySelector('[name="employerCity"]').focus();
        }
        this.showvalidation = true;
        this.toaster.message(
          "Annual income must be greater than or equal to 1",
          2
        );
        return false;
      }
      if (!this.patientData.annual_income) {
        if (this._el.nativeElement.querySelector('[name="annualIncome"]')) {
          this._el.nativeElement.querySelector('[name="annualIncome"]').focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter employer income');
        return false;
      }
    }
    if (this.employer_yes_id == 0) {
      // tslint:disable-next-line:max-line-length
      if (
        this.selectedValue == null ||
        (this.selectedValue == "Others" &&
          (this.other_service_value == null ||
            this.other_service_value.trim().length == 0))
      ) {
        if (this._el.nativeElement.querySelector('[name="selectedValue"]')) {
          this._el.nativeElement
            .querySelector('[name="selectedValue"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please choose a valid payback source');
        return false;
      }
    }
    if (this.employer_yes_id == 2) {
      if (
        !this.patientData.profession ||
        Number(this.patientData.profession.trim().length) === 0
      ) {
        if (this._el.nativeElement.querySelector('[name="employer_name"]')) {
          this._el.nativeElement
            .querySelector('[name="employer_name"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter Your Profession');
        return;
      }
      if (
        !this.patientData.office_address ||
        this.patientData.office_address.trim().length == 0
      ) {
        if (this._el.nativeElement.querySelector('[name="office_address"]')) {
          this._el.nativeElement
            .querySelector('[name="office_address"]')
            .focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter Office Address');
        return;
      }
      if (!this.patientData.office_city_id) {
        // if (this._el.nativeElement.querySelector('[name="office_address_check"]')) {
        //   this._el.nativeElement.querySelector('[name="office_address_check"]').focus();
        // }
        // this.showvalidation  = true;

        this.toaster.message("Please enter valid office zip", 2);
        return;
      }
      if (
        !this.patientData.profession ||
        this.patientData.profession.trim().length == 0
      ) {
        if (this._el.nativeElement.querySelector('[name="profession"]')) {
          this._el.nativeElement.querySelector('[name="profession"]').focus();
        }
        this.showvalidation = true;
        this.toaster.message("Please enter Your Profession", 2);
        return;
      }
      if (
        !this.patientData.annual_income ||
        this.patientData.annual_income.toString().trim().length == 0
      ) {
        if (this._el.nativeElement.querySelector('[name="annualIncome"]')) {
          this._el.nativeElement.querySelector('[name="annualIncome"]').focus();
        }
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter Annual Income');
        return;
      }
      if (
        this.patientData.annual_income &&
        this.patientData.annual_income == 0
      ) {
        if (this._el.nativeElement.querySelector('[name="annualIncome"]')) {
          this._el.nativeElement.querySelector('[name="annualIncome"]').focus();
        }
        this.showvalidation = true;
        this.toaster.message(
          "Annual income should be greater than or equal to 1",
          2
        );
        return;
      }
      if (this.patientData.annual_income == 0) {
        if (this._el.nativeElement.querySelector('[name="annualIncome"]')) {
          this._el.nativeElement.querySelector('[name="annualIncome"]').focus();
        }
        this.showvalidation = true;
        this.toaster.message(
          "Annual income must be greater than or equal to 1",
          3
        );
        return;
      }
    }

    if (this.validateSecondStep() && !form.invalid) {
      // handling DOB for firefox browser
      let dateOfBirth = this.valueSet;
      if (typeof dateOfBirth == "string") {
        dateOfBirth = this.datePipe.transform(dateOfBirth, "yyyy-MM-dd");
        // dateOfBirth = dateOfBirth.slice(4, 8) + '-' + dateOfBirth.slice(0, 2) + '-' + dateOfBirth.slice(2, 4);
      } else {
        dateOfBirth = this.datePipe.transform(dateOfBirth, "yyyy-MM-dd");
      }

      const params = {
        contract_patient_token: this.contractToken,
        patient_first_name: this.patientData.patient_first_name,
        patient_last_name: this.patientData.patient_last_name,
        patient_gender: this.patientData.patient_gender,
        // patient_address: this.patientData.patient_address,
        // patient_mobile: this.patientData.patient_mobile.replace(/[^0-9]/g, ''),
        // city_id: this.patientData.city_id,
        // patient_ssn: this.patientData.patient_ssn,
        dl_number: this.patientData.dl_number,
        date_of_birth: dateOfBirth,
        employer_name: this.patientData.employer_name,
        employer_mobile: this.patientData.employer_mobile
          ? this.patientData.employer_mobile.replace(/[^0-9]/g, "")
          : "",
        employer_address: this.patientData.employer_address_2 ? this.patientData.employer_address + " || " + this.patientData.employer_address_2 : this.patientData.employer_address,
        employer_city: this.patientData.employer_city_id,
        office_address: this.patientData.office_address_2 ? this.patientData.office_address + " || " + this.patientData.office_address_2 :this.patientData.office_address,
        profession: this.patientData.profession,
        office_city_id:
          this.patientData.office_city_id ||
          (this.ofcZips && this.ofcZips[0].city_id),
        office_city:
          this.patientData.office_city ||
          (this.ofcZips && this.ofcZips[0].city),
        office_state:
          this.patientData.office_state ||
          (this.ofcZips && this.ofcZips[0].state_name),
        annual_income: this.patientData.annual_income,
        is_minor: this.patientData.is_minor ? 1 : 0,
        guardian_first_name: this.patientData.guardian_first_name,
        guardian_last_name: this.patientData.guardian_last_name,
        cd_payment_type: 25,
        payback_methods:
          this.selectedValue && this.selectedValue === "Others"
            ? this.other_service_value
            : this.selectedValue,
        device_info: JSON.stringify(this.mainService.device_info()),
        employer_mobile_country_code:
          this.patientData.employer_mobile_country_code,
      };
      this.mainService.setLoader(true);
      this.proposal
        .formApi("post", "edit_pf_details", params)
        .subscribe(
          (data: any) => {
            this.mainService.setLoader(false);
            if (data && typeof data == "string") data = JSON.parse(data);
            if (data.is_error == 0) {
              this.isFirstDisabled = true;
              this.isSecondDisabled = true;
              this.isOpen = false;
              this.isOpen2 = false;
              this.isDownloadContract = false;
              this.current_step = 5;
              this.verified = 1;
              this.mainService.closePayBtn = false;
              // this.toaster.message('success', 'Personal Details added successfully');
              // this.router.navigate(['thanks', this.contractToken]);
            }
            if (data.is_error == 1) {
              if (data.override_text || data.err) {
                this.toaster.message("error", data.override_text || data.err);
                return false;
              }
            }
          },
          (error: any) => {
            console.log(error);
            this.mainService.setLoader(false);
          }
        );
    }
  }

  downloadContract() {
    this.mainService.setLoader(true);
    let params = {
      contract_patient_token: this.contractToken,
      device_info: JSON.stringify(this.mainService.device_info()),
    };
    this.proposal.downloadApi("download_contract_pdf", params, 0).subscribe(
      (data: any) => {
        this.mainService.setLoader(false);

        console.log(data);
      },
      (error: any) => {
        this.mainService.setLoader(false);
        console.log(error);
      }
    );
  }

  getZip(token: string, type: number) {
    this.zipClear("", type);
    if (token.length > 3 && token.length <= 6) {
      this.loadingZip = true;
      this.mainService
        .getZipcode({
          zipcode: token,
          search_canada: 1,
        })
        .subscribe(
          (data: any) => {
            if (data && data.zip_info) {
              if (type === 1) {
                this.zips = data.zip_info;
              } else if (type === 2) {
                this.empZips = data.zip_info;
              } else if (type === 3) {
                this.ofcZips = data.zip_info;
              }
            }
            this.loadingZip = false;
          },
          (error: any) => {
            this.loadingZip = false;
          }
        );
    } else {
      return false;
    }
  }
  submitPersonalDetailsAR() {
    if (
      this.patientData.date_of_birth &&
      JSON.stringify(this.patientData.date_of_birth).indexOf("T") == -1
    ) {
      this.patientData.date_of_birth = this.valueSet ? this.valueSet.split('/') : '';
    }
    const dateOfBirth = this.patientData.date_of_birth[2] + '-' + this.patientData.date_of_birth[0] + '-' + this.patientData.date_of_birth[1];

    const params = {
      contract_patient_token: this.contractToken,
      patient_first_name: this.patientData.patient_first_name,
      patient_last_name: this.patientData.patient_last_name,
      patient_gender: this.patientData.patient_gender,
      dl_number: this.patientData.dl_number,
      date_of_birth: dateOfBirth,
      is_minor: this.patientData.is_minor ? 1 : 0,
      guardian_first_name: this.patientData.guardian_first_name,
      guardian_last_name: this.patientData.guardian_last_name,
      cd_payment_type: 25,
      device_info: JSON.stringify(this.mainService.device_info()),
    };
    this.mainService.setLoader(true);
    this.proposal
      .formApi("post", "edit_pf_details", params)
      .subscribe(
        (data: any) => {
          this.mainService.setLoader(false);
          if (data && typeof data === "string") {
            data = JSON.parse(data);
          }
          if (data.is_error === 0) {
            this.isFirstDisabled = true;
            this.isSecondDisabled = true;
            this.isOpen = false;
            this.isOpen2 = false;
            this.isDownloadContract = false;
            //  this.toaster.message('success', 'Personal Details added successfully');
            // this.router.navigate(["thanks", this.contractToken]);
            this.router.navigate(['/thanks', this.contractToken], { queryParams: { reload: 1 } });
            // this.FinalsuccessModal.show();
          }
          if (data.is_error === 1) {
            if (data.override_text) {
              this.toaster.message("error", data.override_text);
              return false;
            }
          }
        },
        (error: any) => {
          console.log(error);
          this.mainService.setLoader(false);
        }
      );
  }
  selectZip(selectedCity: any, type: any) {
    if (type == 1) {
      // tslint:disable-next-line:max-line-length
      const zip = this.zips.filter((item) => item.city_id === selectedCity)[0]
        ? this.zips.filter((item) => item.city_id === selectedCity)[0]
        : [];
      this.patientData.city_id = zip.city_id;
      this.patientData.city = zip.city;
      this.patientData.state_name = zip.state_name;
      this.patientData.zip = zip.zip;
      this.patientData.zipSelected = true;
    }
    if (type === 2) {
      // tslint:disable-next-line:max-line-length
      const zip = this.empZips.filter(
        (item) => item.city_id === selectedCity
      )[0]
        ? this.empZips.filter((item) => item.city_id === selectedCity)[0]
        : [];
      this.patientData.employer_city_id = zip.city_id;
      this.patientData.employer_city = zip.city;
      this.patientData.employer_state = zip.state_name;
      this.patientData.employer_zip = zip.zip;
      this.patientData.zipEmpSelected = true;
    }
    if (type === 3) {
      // tslint:disable-next-line:max-line-length
      const zip = this.ofcZips.filter(
        (item) => item.city_id === selectedCity
      )[0]
        ? this.ofcZips.filter((item) => item.city_id === selectedCity)[0]
        : [];
      // console.log(zip)
      this.patientData.office_city_id = zip.city_id;
      this.patientData.office_city = zip.city;
      this.patientData.office_state = zip.state_name;
      this.patientData.office_zip = zip.zip;
      this.patientData.office_zipSelected = true;
    }
  }

  zipClear(event: any, type: any) {
    if (type == 1) {
      this.patientData.city_id = null;
      this.patientData.city = null;
      this.patientData.state_name = null;
      this.patientData.zip = null;
      this.patientData.zipSelected = false;
    }
    if (type == 2) {
      this.patientData.employer_city_id = null;
      this.patientData.employer_city = null;
      this.patientData.employer_state = null;
      this.patientData.employer_zip = null;
      this.patientData.zipEmpSelected = true;
    }
    if (type == 3) {
      this.patientData.office_city_id = null;
      this.patientData.office_city = null;
      this.patientData.office_state = null;
      this.patientData.office_zip = null;
      this.patientData.zipOfcSelected = true;
    }
  }

  selectEmpZip(zip: any) {
    this.patientData.employer_city_id = zip.city_id;
    this.patientData.employer_city = zip.city;
    this.patientData.employer_state = zip.state_name;
    this.patientData.employer_zip = zip.zip;
    this.patientData.zipEmpSelected = true;
  }

  onFileInputClick(e) {
    this.fileUpload.nativeElement.value = "";
  }

  fileChangeEvent(event: any) {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length > 0
    ) {
      const file = event.target.files;
      this.fileName = file[0].name;
      localStorage.setItem("fileName", this.fileName);
      if (file[0].size <= 0) {
        this.toaster.message("Invalid file.", 3);
        return false;
      }

      // tslint:disable-next-line:max-line-length
      if (
        file[0].type !== "image/png" &&
        file[0].type !== "application/pdf" &&
        file[0].type !== "image/jpeg" &&
        file[0].type !== "image/jpg"
      ) {
        this.toaster.message(
          "File type not supported. Please upload a valid file(.pdf, .jpeg, .png).",3
        );
        return false;
      }

      if (file[0].size > 10485760) {
        this.toaster.message(
          "File size must be less than 10MB.",3
        );
        return false;
      }

      if (file[0].type === "application/pdf") {
        this.mainService.setLoader(true);
        this.uploadedDoc(file[0]);
      } else {
        if (
          file[0].type === "image/png" ||
          file[0].type === "image/jpeg" ||
          file[0].type === "image/jpg"
        ) {
          const image: File = file[0];
          this.mainService.setLoader(true);
          this.compressImage
            .compress(image)
            .pipe(take(1))
            .subscribe((compressedImage) => {
              this.uploadedDoc(compressedImage);
            });
        }
      }
    }
  }

  uploadedDoc(file) {
    if (file) {
      const formData = new FormData();
      formData.append("dl_doc", file);
      formData.append("contract_id", this.planInfo.contract_id);
      formData.append(
        "patient_id",
        this.patientData.patient_id ? this.patientData.patient_id : "0"
      );
      formData.append("token", this.contractToken);
      this.proposal.formApi("post", "upload_cus_dl", formData).subscribe(
        (data: any) => {
          this.mainService.setLoader(false);
          if (data && typeof data === "string") {
            data = JSON.parse(data);
          }
          if (data.is_error === 1) {
            if (data.override_text) {
              this.toaster.message("error", data.override_text);
            } else {
              this.toaster.message("error", data.error);
            }
          } else if (data && data.data && data.data.url) {
            this.patientData.dl_doc = data.data.url;
            this.patientData.dl_id = data.data.id;
            this.toaster.message(
              "success",
              data.override_text
                ? data.override_text
                : "Document uploaded successfully"
            );
          } else {
            this.checkToken();
          }
        },
        (error: any) => {
          this.mainService.setLoader(false);
        }
      );
    } else {
      this.toaster.message("Please select valid file",3);
    }
  }

  deleteUploadedDoc() {
    let params = {
      doc_id: this.doc_id,
      token: this.contractToken,
      patient_id: this.patientData.patient_id,
    };
    this.mainService.setLoader(true);
    this.proposal
      .api("post", "delete_cus_dl", this.mainService.urlParams(params))
      .subscribe(
        (data: any) => {
          this.mainService.setLoader(false);
          if (data && typeof data === "string") {
            data = JSON.parse(data);
          }
          if (data.is_error === 0) {
            this.toaster.message(
              "success",
              data.override_text
                ? data.override_text
                : "Document deleted successfully"
            );
            this.patientData.dl_doc = null;
          }
          if (data.is_error === 1) {
            if (data.flag === 584) {
              this.patientData.dl_doc = null;
              this.patientData.dl_id = null;
            }
            if (data.override_text) {
              this.toaster.message("error", data.override_text);
              return false;
            }
          }
        },
        (error: any) => {
          console.log(error);
          this.mainService.setLoader(false);
        }
      );
  }

  deleteDocPopUp(id) {
    this.doc_id = id;
    if (this.doc_id) {
      this.deleteUploadedDoc();
    }
  }

  checkToken() {
    let params = {
      contract_token: this.contractToken,
      timezone: this.mainService.getCurrentTimezone(),
    };
    this.mainService.setLoader(true);
    this.proposal
      .api("post", "check_email_code_apf", this.mainService.urlParams(params))
      .subscribe((data: any) => {
        this.mainService.setLoader(false);
        if (data.is_error) {
          this.mainService.setLoader(true);
        }
        if (data && data.validation_rules) {
          this.regexMode= data && data.validation_rules && data.validation_rules.DL;
          console.log(this.regexMode,data);
          
        }
        if (data.feature_list && data.feature_list.length) {
          this.mainService.featureList = data.feature_list;
        }
        if (data.split_request_data && data.split_request_data.length > 0) {
          this.planInfo = data.split_request_data[0];
          this.planInfo = this.planInfo.filter((item: any) => {
            item.contract_code = localStorage.getItem('contract_code')
            return item;
          })
          this.proposal.sendData(data);

        } else if (!data.is_error) {
          this.proposal.sendData(data);
        }
        this.mainService.setLoader(false);
      });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-md modal-445 modal-dialog-centered",
      ignoreBackdropClick: true,
      keyboard: false,
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.modalRef.hide();
      }
    });
  }

  selectEmployerDetails(employer) {
    // if (employer == 'employer_yes') {
    //     this.employer_yes_id=true;
    //     this.employer_no_id=false;
    // } else if (employer == 'employer_no') {
    //     this.employer_yes_id=false;
    //     this.employer_no_id=true;
    // } else {
    //   this.employer_yes_id=false;
    //   this.employer_no_id=false;
    // }
  }

  service() {
    if (this.selectedValue == "Others") {
      this.other_services = true;
    } else {
      this.other_services = false;
    }
  }

  changeOfficeAddress() {
    if (this.office_address_check) {
      this.patientData.office_city_id = this.patientData.city_id;
      this.patientData.office_city = this.patientData.city;
      this.patientData.office_state = this.patientData.state_name;
      this.patientData.office_zip = this.patientData.zip;
      this.patientData.office_address = this.patientData.patient_address.includes("||") ? this.patientData.patient_address.split("||")[0].trim() : this.patientData.patient_address;
      this.patientData.office_address_2 = this.patientData.patient_address.includes("||") ? this.patientData.patient_address.split("||")[1].trim() : this.patientData.office_address_2 ? this.patientData.office_address_2 : " ";
    } else {
      this.patientData.office_city_id = "";
      this.patientData.office_city = "";
      this.patientData.office_state = "";
      this.patientData.office_zip = "";
      this.patientData.office_address = "";
      this.patientData.office_address_2 = "";
    }
  }

  enterNumberOnly(event) {
    if (
      event.target.value &&
      event.target.value.length == 1 &&
      event.target.value == 0
    ) {
      return false;
    }
    if (event.target.length > 7) {
      return false;
    }
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  downloadContract_new() {
    // tslint:disable-next-line:max-line-length
    this.proposal.downloadContract(
      this.patientData.payRecurring.payToken,
      this.contractToken,
      this.patientData.payRecurring.pay_recurring
    );
  }

  changeFields(field, value) {
    this.patientData[field] = value;
  }

  getZipselected(zipObj, type?) {
    try {
      if (type === 2) {
        this.empZips = zipObj;
        this.empzip = zipObj.zip;
        this.patientData.employer_zip = zipObj.zip;
        this.patientData.employer_state = zipObj.state_name;
        this.patientData.employer_city = zipObj.city;
        this.patientData.employer_city_id = zipObj.city_id;
        this.patientData.employer_address = zipObj.formatted_address || (zipObj.item && zipObj.item.formatted_address);
      } else if (type === 3) {
        this.ofcZips = zipObj;
        this.ofczip = zipObj.zip;
        this.patientData.office_zip = zipObj.zip;
        this.patientData.office_state = zipObj.state_name;
        this.patientData.office_city = zipObj.city;
        this.patientData.office_city_id = zipObj.city_id;
        this.patientData.office_address = zipObj.formatted_address || (zipObj.item && zipObj.item.formatted_address);
        this.office_address_check = false;
      }
    } catch (err) {
      console.log(err);
    }
  }

  removeZip(value) {
    this.employer_yes_id = value;

    // this.empzip = '';
    // this.patientData.employer_zip = '';
    // this.patientData.employer_state = '';
    // this.patientData.employer_city = '' ;
    // this.patientData.employer_city_id = '';
    // this.ofcZips = '';
    // this.ofczip = '';
    // this.patientData.office_zip = '';
    // this.patientData.office_state = '';
    // this.patientData.office_city = '' ;
    // this.patientData.office_city_id = '';
    this.patientData.annual_income = "";
    this.showvalidation = false;
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if (
        isHovered &&
        !!navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform) &&
        "ontouchstart" in window
      ) {
        (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  changeFlag(i, data = []) {
    // tslint:disable-next-line:max-line-length
    this.mainService.country_data =
      this.mainService.country_data && this.mainService.country_data.length
        ? this.mainService.country_data
        : data;
    this.patientData.employer_mobile_country_code =
      this.mainService.country_data[i]["mobile_code"];
    this.flag_code = (
      this.mainService.country_data[i]["country_code"] + ""
    ).toLocaleLowerCase();
  }

  continueLogin() {
    if (/(android)/i.test(navigator.userAgent) || this.isIOS()) {
      this.paymentModal.show();
    } else {
      this.openPanel();
    }
  }

  isIOS() {
    const iDevices = [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ];

    if (navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }
  openPanel() {
    let url = "";
    if (this.verified == 1) {
      url = "verify?link_id=" + this.contractToken;
    }
    console.log(environment.customer_panel_link);
    window.open(environment.customer_panel_link + url, "_blank");
  }
  openApp() {
    if (/(android)/i.test(navigator.userAgent) || this.isIOS()) {
      window.open(environment.app_deep_link, "_blank");
    } else {
      this.openPanel();
    }
  }

  // addZero(event: any): void {
  //   this.toaster_error = '';
  //   this.showvalidation = false;
  //   const inputValue = event.target.value;
  //   // Check if the month part needs '0'
  //   if (inputValue.length >= 2 && inputValue.indexOf('/') === 1) {
  //     const month = inputValue.substring(0, 2);
  //     const months = parseInt(month, 10);
  //     if (months > 0 && months <= 9) {
  //       const maskedValue = '0' + months + inputValue.substring(2);
  //       this.patientData.date_of_birth = maskedValue;
  //       return;
  //     }
  //   } else if (inputValue.length >= 5 && inputValue.indexOf('/') === 2) {
  //     const day = inputValue.substring(3, 5);
  //     const numericDay = parseInt(day, 10);
  //     if (numericDay > 0 && numericDay <= 9) {
  //       const maskedValue = inputValue.substring(0, 3) + '0' + numericDay + inputValue.substring(5);
  //       this.patientData.date_of_birth = maskedValue;
  //     }
  //   }
  // }

  blurDataUpdate(event) {
    const splitSeries = this.dateOfBirthMask.split(this.specialCharacter[0]);
    const formateSeriesd = splitSeries.findIndex((x) => x === "d0");
    if (event.target.value) {
      const splittedValue = (event.target.value + "").split(
        this.specialCharacter[0]
      );
      if (
        splittedValue &&
        splittedValue[formateSeriesd] &&
        splittedValue[formateSeriesd].length == 1
      ) {
        splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
        this.patientData.date_of_birth = splittedValue.join(
          this.specialCharacter[0]
        );
      }
    }
  }
  addZero(event: any): void {
    const splitSeries = this.dateOfBirthMask.split(this.specialCharacter[0]);
    const formateSeriesm = splitSeries.findIndex((x) => x === "M0");
    const formateSeriesd = splitSeries.findIndex((x) => x === "d0");
    const formateSeriesy = splitSeries.findIndex((x) => x === "0000");
    const monthIndex = formateSeriesm;
    const dayIndex = formateSeriesd;
    const yearIndex = formateSeriesy;

    if (event.target.value && event.data) {
      this.toaster_error = "";
      const splittedValue = (event.target.value + "").split(
        this.specialCharacter[0]
      );
      if (splittedValue && splittedValue[formateSeriesm]) {
        if (
          splittedValue &&
          splittedValue[formateSeriesm] &&
          splittedValue[formateSeriesm].length == 1 &&
          splittedValue[formateSeriesm] >=
            (monthIndex == 0 ? "1" : monthIndex == 1 ? "2" : "2")
        ) {
          if (
            monthIndex == 0 &&
            splittedValue[formateSeriesm][0] == "1" &&
            !splittedValue[formateSeriesd]
          ) {
            this.patientData.date_of_birth = splittedValue.join(
              this.specialCharacter[0]
            );
          } else {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
            this.patientData.date_of_birth = splittedValue.join(
              this.specialCharacter[0]
            );
          }
        } else if (
          dayIndex == 2 &&
          monthIndex == 1 &&
          splittedValue &&
          splittedValue[formateSeriesm]
        ) {
          if (
            splittedValue[formateSeriesm][0] != "0" &&
            splittedValue[formateSeriesm][1] >= "3"
          ) {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
          } else if (
            splittedValue && splittedValue[formateSeriesm] && (splittedValue[formateSeriesm].length == 1 && splittedValue[formateSeriesm][0] == "1" && (splittedValue[formateSeriesd] &&
            splittedValue[formateSeriesd][0] >= "3"))
          ) {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
          }
          this.patientData.date_of_birth = splittedValue.join(
            this.specialCharacter[0]
          );
        } else if (
          dayIndex == 0 &&
          monthIndex == 1 &&
          this.specialCharacter[0]
        ) {
          if (this.specialCharacter && this.specialCharacter[0].includes("/")) {
            if (
              splittedValue &&
              splittedValue[formateSeriesm] &&
              splittedValue[formateSeriesy] &&
              splittedValue[formateSeriesm][0] == "1" &&
              splittedValue[formateSeriesy][0] >= "3"
            ) {
              splittedValue[formateSeriesm] =
                "0" + splittedValue[formateSeriesm];
              this.patientData.date_of_birth = splittedValue.join(
                this.specialCharacter[0]
              );
            }
          }
          if (splittedValue[formateSeriesm] > "12") {
            splittedValue[formateSeriesm] = "0" + splittedValue[formateSeriesm];
            this.patientData.date_of_birth = splittedValue.join(
              this.specialCharacter[0]
            );
          }
        }
      }
      if (splittedValue && splittedValue[formateSeriesd]) {
        if (
          splittedValue &&
          splittedValue[formateSeriesd].length == 1 &&
          splittedValue[formateSeriesd] > "3"
        ) {
          splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
          this.patientData.date_of_birth = splittedValue.join(
            this.specialCharacter[0]
          );
        } else if (
          splittedValue.length - 1 > formateSeriesd &&
          splittedValue[formateSeriesd].length == 1
        ) {
          splittedValue[formateSeriesd] = "0" + splittedValue[formateSeriesd];
          this.patientData.date_of_birth = splittedValue.join(
            this.specialCharacter[0]
          );
        }
      }
    }
  }
  handleKeyDown(event: KeyboardEvent): void {
    // Check if the pressed key is not the left (37) or right (39) arrow key
    if (event.key === "ArrowLeft") {
      // Prevent the default behavior for other keys (disallow typing)
      event.preventDefault();
    }
  }
  handleMouseDown(event: MouseEvent): void {
    // Check if the pressed key is not the left (37) or right (39) arrow key
    if (
      event.type === "mousedown" &&
      this.patientData &&
      this.patientData.date_of_birth &&
      this.patientData.date_of_birth.length >= 5
    ) {
      // Prevent the default behavior for other keys (disallow typing)
      event.preventDefault();
    } else if (event.type === "click") {
      const yourInputElement = document.getElementById("element");
      if (yourInputElement) {
        yourInputElement.focus();
      }
    }
  }

  regexCheck(name: any) {
    let inputValue = name && name.target && name.target.value;
    const allowedChars = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    if (inputValue !== allowedChars) {
      this.Dlshowvalidation = true
      console.log("Invalid input: Special characters detected.");
      return
    }
    this.Dlshowvalidation = false
    let regexPattern = this.regexMode.regex;
    regexPattern = regexPattern && regexPattern.slice(1, -1);
    regexPattern = new RegExp(regexPattern)
    if (!regexPattern.test(inputValue)) {
      this.Dlshowvalidation = true
      return;
    }
    this.Dlshowvalidation = false;
  }
  australiaChange(val) {
    this.mainService.country_data$.subscribe(data => {
      if (data && data.length) {
        this.mobile_validation = data.filter(item => val == item.mobile_code)
        this.updateMasking(this.mobile_validation && this.mobile_validation[0] && this.mobile_validation[0].country_phone_format);
      }
    })
  }
}
